import { ChangesHistoryService } from '../services/changes_history.service'
import {
    ChangesHistoryGetListParams,
    ChangesHistoryGetListResponseT,
    HistoryTypesGetListResponseT,
} from '../types/changes_history.types'

const changesHistoryService = new ChangesHistoryService()

class ChangesHistory {
    getList(
        page: number,
        params?: ChangesHistoryGetListParams
    ): Promise<ChangesHistoryGetListResponseT> {
        return changesHistoryService.getList(page, params)
    }

    getHistoryTypes(): Promise<HistoryTypesGetListResponseT> {
        return changesHistoryService.getHistoryTypes()
    }
}

export const changes_history = new ChangesHistory()
